function Footer() {
    return (
        <footer id="footer">
            <div className="d-flex justify-content-center pt-4 pb-2 mt-5">
                <p>Made with ❤️ by Pritish</p>
            </div>
        </footer>
    );
}

export default Footer;
